import { render, staticRenderFns } from "./pay_type.vue?vue&type=template&id=3125937e"
import script from "./pay_type?vue&type=script&lang=js&external"
export * from "./pay_type?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports